import React from 'react';

function RoomManagementIcon({ color = '#000000', size = 24 }) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.66989 15.2998L9.19989 19.8298C11.0599 21.6898 14.0799 21.6898 15.9499 19.8298L20.3399 15.4398C22.1999 13.5798 22.1999 10.5598 20.3399 8.6898L15.7999 4.1698C14.8499 3.2198 13.5399 2.7098 12.1999 2.7798L7.19989 3.0198C5.19989 3.1098 3.60989 4.6998 3.50989 6.6898L3.26989 11.6898C3.20989 13.0398 3.71989 14.3498 4.66989 15.2998Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.99988 12C11.3806 12 12.4999 10.8807 12.4999 9.5C12.4999 8.11929 11.3806 7 9.99988 7C8.61917 7 7.49988 8.11929 7.49988 9.5C7.49988 10.8807 8.61917 12 9.99988 12Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
      />
    </svg>
  );
}

export default RoomManagementIcon;
